export const fonts = {
  default: 'Montserrat, Roboto, sans-serif',
  admin: 'Poppins, Montserrat, sans-serif',
} as const;
